import React, { useCallback, useContext, useEffect, useState } from 'react'
import { LoadingPage } from '../LoadingPage/LoadingPage'
import { NotFoundPage } from '../NotFoundPage/NotFoundPage'
import { getUserPermissionsByUserEmail } from '../../api/usersModule/getters'
import UserContext from '../../utils/Contexts/UserContext';
import '../Skus/SkusPage.css';
import { NotificationsPanel } from './NotificationsPanel';
import webSocketService from '../../services/WebSocketService';

const moduleName = 'Notificaciones';
export const NotificationsPage = () => {
	const [userPermissions, setUserPermissions] = useState([]);
	const [loading, setLoading] = useState(true);
	const user = useContext(UserContext);

	const getPermissions = async () => {
		setLoading(true);

		let permissions = {
			Consultar: false,
			Crear: false,
			Editar: false,
			Eliminar: false,
		};

		try {
			permissions = await getUserPermissionsByUserEmail(
				user.attributes['email'],
				user.attributes['custom:project'],
				moduleName
			);
			try {
				permissions['Consultar']
					? setUserPermissions(permissions)
					: setUserPermissions([]);
			} catch (error) {
				permissions['Consultar'] = false;
			}
			setUserPermissions(permissions);
			setLoading(false);
		} catch (error) {
			setLoading(false);
		}
	};

	// Función temporal para crear notificación de prueba de dispatch order
	const createTestDispatchNotification = () => {
		const testNotification = {
			id: Date.now(),
			title: "Actualización de Orden de Despacho",
			message: "Le informamos que se ha actualizado la orden de despacho con identificador PLNL01443-31 por parte de [Prodenvases S.A.S]. Se han actualizado los siguientes productos: SKU E003001: 7800 unidades, descripción: Envase de Polietileno Transparente con Tapa Hermética de 500ml para Productos Alimenticios, SKU E003104: 900 unidades, descripción: Contenedor de Plástico Reciclable con Sistema de Cierre Seguro y Etiqueta Adhesiva Resistente al Agua, SKU E003205: 1250 unidades, descripción: Botella de Vidrio Ámbar con Dispensador Automático y Protección UV para Conservación de Líquidos Sensibles.",
			type: "info",
			date: new Date().toISOString(),
			typeInformation: "DispatchOrder"
		};

		// Agregar directamente al array de notificaciones sin hacer reload de la API
		webSocketService.notifications = [testNotification, ...webSocketService.notifications];
		webSocketService.pagination.totalItems += 1;
		webSocketService.notifyObservers();
		
		console.log('Notificación de prueba creada:', testNotification);
	};

	useEffect(() => {
		getPermissions();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	return (
		<>
			{userPermissions['Consultar'] ? (
				<div
					style={{
						flex: '1 1 auto',
						display: 'flex',
						flexFlow: 'column',
						height: '100vh',
						overflowY: 'auto',
					}}
				>
					<div
						style={{
							padding: '20px 5%',
						}}
					>
						{/* Botón temporal para probar notificación de dispatch order */}
						{/* <div style={{ marginBottom: '20px', padding: '15px', backgroundColor: '#f8f9fa', border: '1px solid #dee2e6', borderRadius: '8px' }}>
							<h6 style={{ color: '#146284', marginBottom: '10px' }}>🧪 Prueba de Notificación de Dispatch Order</h6>
							<p style={{ fontSize: '14px', color: '#6c757d', marginBottom: '10px' }}>
								Haz clic en el botón para crear una notificación de prueba y ver el nuevo formato organizado.
							</p>
							<button 
								onClick={createTestDispatchNotification}
								style={{
									backgroundColor: '#146284',
									color: 'white',
									border: 'none',
									padding: '8px 16px',
									borderRadius: '4px',
									cursor: 'pointer',
									fontSize: '14px'
								}}
							>
								Crear Notificación de Prueba
							</button>
						</div> */}

						{/* <div className="mt-4">
						<button onClick={handleClickChangeSocketUrl}>
							Click Me to change Socket Url
						</button>
						<button
							onClick={handleClickSendMessage}
							disabled={readyState !== ReadyState.OPEN}
						>
							Click Me to send 'Hello'
						</button>
						<span>The WebSocket is currently {connectionStatus}</span>
						{lastMessage ? <span>Last message: {lastMessage.data}</span> : null}
						<ul>
							{messageHistory.map((message, idx) => (
								<span key={idx}>{message ? message.data : null}</span>
							))}
						</ul>
					</div> */}
						<NotificationsPanel />
					</div>
				</div>
			) : loading ? (
				<LoadingPage />
			) : (
				<NotFoundPage />
			)}
		</>
	)
}
